import styled from '@emotion/styled'

import { ModalHeader, SimpleModal, Space, Typography } from '@/components/core-v2'

import Icon from '../../../../components/core-v2/atoms/Icon'

const StyledTable = styled.table`
  &,
  th,
  td {
    border: 1px solid var(--White90);
    border-collapse: collapse;
  }
  th {
    padding: 10px;
    text-align: left;
  }
  thead > tr {
    background: var(--White95);
  }
  tbody > tr:nth-of-type(1) {
    color: var(--Success);
    background: var(--SuccessBG);
  }
  tbody > tr:nth-of-type(2) {
    color: var(--Error);
    background: var(--ErrorBG);
  }
  tbody > tr:nth-of-type(1) th,
  tbody > tr:nth-of-type(2) th {
    font-weight: 600 !important;
  }
`

const Title = ({ children }: { children: string }) => (
  <Typography fontSize="13px" fontWeight="700" letterSpacing="0px" variant="b3">
    {children}
  </Typography>
)

const SubText = ({ children }: { children: string }) => (
  <Typography fontSize="13px" letterSpacing="0px" variant="b3">
    {children}
  </Typography>
)

export const PortfolioApprovalInfoModal = ({ onClose }: { onClose: () => void }) => (
  <SimpleModal>
    <ModalHeader onClickClose={onClose}>Portfolio approval process</ModalHeader>
    <Space isflex flexDirection="column" p={6}>
      <Space mb={5}>
        <Space mb={2}>
          <Title>1. Submitting</Title>
        </Space>
        <SubText>
          Once a portfolio has been submitted to the approval process, it can no longer be edited by
          the user.
        </SubText>
      </Space>
      <Space>
        <Space mb={2}>
          <Title>2. Approving or rejecting</Title>
        </Space>
        <SubText>
          At this step, the portfolio will be formally approved or rejected by the bank.
        </SubText>
      </Space>
      <Space mt={5}>
        <StyledTable>
          <thead>
            <tr>
              <th aria-label="Status">&nbsp;</th>
              <th>
                <Title>New portfolio</Title>
              </th>
              <th>
                <Title>Edit to an existing portfolio</Title>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                <Space isflex>
                  <Space mr={1}>
                    <Icon name="circleCheck" size="default" />
                  </Space>
                  Approved
                </Space>
              </th>
              <th>Available for immediate use</th>
              <th>Available for immediate use</th>
            </tr>
            <tr>
              <th>
                <Space isflex>
                  <Space mr={1}>
                    <Icon name="circleX" size="default" />
                  </Space>
                  Rejected
                </Space>
              </th>
              <th>After 24 hours, it will be removed</th>
              <th>Restored to its previous state</th>
            </tr>
          </tbody>
        </StyledTable>
      </Space>
    </Space>
  </SimpleModal>
)
